import { DeleteOutlined, EyeOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Button, List, Modal, Skeleton, Tooltip, notification } from "antd";
import { useState } from "react";
import { deleteAnexoClientesById } from "../../../../api/clientes";
import { FsBtnDownload } from "../../../../components/FsBtnDownload";
import PdfReader from "../../../../components/PdfReader";
import { FileType } from "../../../../types/FileType";

type Props = {
    idCliente: string | undefined;
    loading: boolean;
    listFiles: FileType[];
    initLoading: boolean;
    loadAnexos: () => Promise<void>
};


export default function AnexosComponent({ idCliente, loading, listFiles, initLoading, loadAnexos }: Props) {
    const [openModalPDF, setOpenModalPDF] = useState(false);
    const [openModalDeletePDF, setOpenModalDeletePDF] = useState(false);
    const [archiveSelected, setArchiveSelected] = useState<any>(undefined); // eslint-disable-line
    const [loadingButton, setLoadingButton] = useState(false);


    // useEffect(() => {
    //     loadAnexos();
    // }, [loading]);

    return (
        <>
            <List
                className="demo-loadmore-list"
                loading={initLoading}
                itemLayout="horizontal"
                dataSource={listFiles}
                renderItem={(item: FileType) => (
                    <List.Item
                        actions={[
                            <Tooltip title="Visualizar PDF">
                                <Button icon={<EyeOutlined />} onClick={() => {
                                    setArchiveSelected(item)
                                    setOpenModalPDF(true)
                                }
                                }></Button>
                            </Tooltip>,
                            <Tooltip title="Baixar PDF">
                                <FsBtnDownload itemDownload={{ idCliente, ...item }} />
                            </Tooltip>,
                            <Tooltip title="Apagar PDF">
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        setArchiveSelected(item)
                                        setOpenModalDeletePDF(true)
                                    }}
                                    loading={loadingButton}
                                    icon={<DeleteOutlined />}
                                >
                                </Button>
                            </Tooltip>,
                        ]}
                    >
                        <Skeleton avatar title={false} loading={initLoading} active>
                            <List.Item.Meta
                                avatar={<FilePdfOutlined />}
                                // title={`${item.file_name}`}
                                description={`${item.file_name}`}
                            />
                        </Skeleton>
                    </List.Item>
                )}
            />
            {/* Visualizador de PDF */}
            <Modal
                title="Visualizar PDF"
                centered
                open={openModalPDF}
                onOk={() => setOpenModalPDF(false)}
                onCancel={() => setOpenModalPDF(false)}
                width={1200}
            >
                <PdfReader pdfUrl={archiveSelected?.file_path} />
            </Modal>
            {/* Modal apagar PDF */}
            <Modal
                open={openModalDeletePDF}
                title="Atenção!"
                confirmLoading={loadingButton}
                onOk={() => {
                    setLoadingButton(true);
                    deleteAnexoClientesById(archiveSelected).then(() => {
                        notification.success({
                            message: "Sucesso",
                            description:
                                "Anexo removido com sucesso",
                        });
                        setLoadingButton(false);
                        loadAnexos();
                        setOpenModalDeletePDF(false);
                    });
                }}
                onCancel={() => setOpenModalDeletePDF(false)}
                footer={(_, { OkBtn, CancelBtn }) => (
                    <>
                        <CancelBtn />
                        <OkBtn />
                    </>
                )}
            >
                <p>Você tem certeza que deseja apagar o anexo?</p>
            </Modal>
        </>
    );
}
